import { useEffect, useState } from "react";

const API_URL = "https://todo-backend-uwty.onrender.com/api/todos";

function App() {
  const [todos, setTodos] = useState([]);
  const [title, setTitle] = useState("");

  const [loading, setLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);

  const getTodos = async () => {
    const res = await fetch(API_URL);
    const data = await res.json();
    setTodos(data);
  };

  useEffect(() => {
    getTodos();
  }, []);

  const addTodo = async () => {
    if (!title) return;

    setLoading(true);

    await fetch(API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ title }),
    });

    setTitle("");
    await getTodos();
    setLoading(false);
  };

  // ❌ Delete with loader
  const deleteTodo = async (id) => {
    setDeletingId(id);

    await fetch(`${API_URL}/${id}`, {
      method: "DELETE",
    });

    await getTodos();
    setDeletingId(null);
  };

  // ✅ Toggle
  const toggleTodo = async (todo) => {
    await fetch(`${API_URL}/${todo._id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ completed: !todo.completed }),
    });
    getTodos();
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>✨ Todo App</h1>

        {/* Input */}
        <div style={styles.inputContainer}>
          <input
            style={styles.input}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter your task..."
          />
          <button style={styles.addBtn} onClick={addTodo}>
            {loading ? (
              <>
                <span className="loader"></span> Adding
              </>
            ) : (
              "Add"
            )}
          </button>
        </div>

        {/* Todo List */}
        <ul>
          {todos.map((todo) => (
            <li key={todo._id} className="todo">
              <span
                onClick={() => toggleTodo(todo)}
                className={todo.completed ? "done" : ""}
              >
                {todo.title}
              </span>

              <button
                style={styles.deleteBtn}
                onClick={() => deleteTodo(todo._id)}
                disabled={deletingId === todo._id}
              >
                {deletingId === todo._id ? (
                  <>
                    <span className="loader"></span> Deleting
                  </>
                ) : (
                  "Delete"
                )}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #667eea, #764ba2)",
    fontFamily: "Arial",
  },
  todo:{
    display: "flex",
    flexDirection:'row',
    gap:20,
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    background: "#fff",
    padding: "30px",
    borderRadius: "15px",
    width: "350px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
  },
  inputContainer: {
    display: "flex",
    gap: "10px",
    marginBottom: "20px",
  },
  input: {
    flex: 1,
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #ddd",
    outline: "none",
  },
  addBtn: {
    background: "#667eea",
    color: "#fff",
    border: "none",
    padding: "10px 15px",
    borderRadius: "8px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px"
  },
  todoItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    borderBottom: "1px solid #eee",
  },
  todoText: {
    cursor: "pointer",
  },
  deleteBtn: {
    background: "#ff4d4f",
    color: "#fff",
    border: "none",
    padding: "6px 10px",
    borderRadius: "6px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "40px"
  },
};

export default App;